import { createErrorRegistry } from './errors/registry.errors';

export const researcherErrorRegistry = createErrorRegistry({});
